module.exports = __webpack_public_path__ + "static/media/uriel-soberanes.1095a459.jpg";